const TabLinksListItem = ({ text, active, imgSrc, onClick }) => {
  let str =
    "tablink clickable-active2 d-flex align-items-center gap-2 py-2 px-4 p3-bg rounded-17";
  if (active === true) {
    str += " active";
  }
  return (
    <li className="nav-links">
      <button onClick={onClick} className={str}>
        <img src={imgSrc} alt="Icon" width={16} />
        {text}
      </button>
    </li>
  );
};

export default TabLinksListItem;
